// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyAhGjRibTm0Q3zNs3KcxOVrrz28nG6KVa4",
  authDomain: "alpaago-testbench.firebaseapp.com",
  projectId: "alpaago-testbench",
  storageBucket: "alpaago-testbench.appspot.com",
  messagingSenderId: "713732302795",
  appId: "1:713732302795:web:7bf6aeebe8447e1414784e",
  measurementId: "G-W7D0HJZ4LE",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);


